import { IField, IFormButton } from 'app/services/api5-service/api.interface';
import { getButtonList } from 'components/form-button/form-button.utils';
import { IFormButtonUi } from 'components/form-button/model';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ButtonProps } from './model/button-props.interface';

import { ISPFieldConfig, ISPFieldType, ISPFormState } from '../../model';

/**
 * Get stream of button model
 *
 * @param control
 * @param state
 */
export function getButton$(
  control: IFormButton,
  state: ISPFormState,
): Observable<IFormButtonUi> {
  return state.docSubject.pipe(
    map(doc => getButtonList(doc, [control], state.showHints)[0]),
    tap(button => state.buttonsService.addButton(button, true)),
  );
}

/**
 * Get props for button field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getButtonProps(
  control: IFormButton,
  field: IField,
  state: ISPFormState,
): ButtonProps {
  return {
    originalButton: control,
    originalField: field,
    button$: getButton$(control, state),
    style: {
      flexGrow: control.$fullwidth === 'yes' ? '1' : undefined,
    },
  };
}

/**
 * Get config for button field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getButtonConfig(
  control: IFormButton,
  field: IField,
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.Button> {
  const props = getButtonProps(control, field, state);

  return {
    type: ISPFieldType.Button,
    props,
  };
}
